"use client";

import type { HomeKeyFeature } from "@/lib/page-content-types";

const defaultFeatures: HomeKeyFeature[] = [
  {
    number: "01",
    title: "Reference Layer",
    description: "Complete atlas of regions, grapes, wineries, wines, and vintages.",
  },
  {
    number: "02",
    title: "Decision Support",
    description: "Clear profiles, ratings, and comparisons to guide your choices.",
  },
  {
    number: "03",
    title: "Editorial Trust",
    description: "Transparent methodology with citations and version history.",
  },
  {
    number: "04",
    title: "Community",
    description: "Personal cellar, notes, and ratings make it useful repeatedly.",
  },
];

export function KeyFeatures({ features = defaultFeatures }: { features?: HomeKeyFeature[] }) {
  return (
    <section className="py-32 lg:py-48" style={{ backgroundColor: "var(--linen)" }}>
      <div className="mx-auto max-w-screen-2xl px-8 lg:px-16">
        <div className="mx-auto max-w-7xl">
          <div className="mb-24">
            <span
              style={{
                fontFamily: "var(--font-body)",
                fontSize: "var(--text-xs)",
                fontWeight: 400,
                color: "var(--oxblood)",
                letterSpacing: "0.15em",
                textTransform: "uppercase",
              }}
            >
              What We Do
            </span>
          </div>

          <div className="grid gap-20 lg:grid-cols-2">
            {features.map((feature) => (
              <div key={feature.number} className="group">
                <div className="mb-6">
                  <span
                    style={{
                      fontFamily: "var(--font-display)",
                      fontSize: "var(--text-sm)",
                      fontWeight: 300,
                      color: "var(--slate)",
                      letterSpacing: "0.05em",
                    }}
                  >
                    {feature.number}
                  </span>
                </div>
                <h3
                  className="mb-4"
                  style={{
                    fontFamily: "var(--font-display)",
                    fontSize: "var(--text-2xl)",
                    fontWeight: 400,
                    color: "var(--charcoal)",
                    letterSpacing: "-0.01em",
                  }}
                >
                  {feature.title}
                </h3>
                <p
                  style={{
                    fontFamily: "var(--font-body)",
                    fontSize: "var(--text-base)",
                    lineHeight: "var(--line-height-body)",
                    color: "var(--slate)",
                    fontWeight: 300,
                    maxWidth: "400px",
                  }}
                >
                  {feature.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
